var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ir-header-regular",style:(`background-image:url('${_vm.getCompany.banner_img}');`)},[_c('div',{staticClass:"ir-header-icon-regular"},[_c('a',{attrs:{"href":_vm.getCompany.home_url}},[_c('img',{attrs:{"src":_vm.getCompany.logo_img}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }